import { ReservationQuestionType } from "./reservation-question-type.enum";
import { ReservationQuestion } from "./reservation-questions";

export class ReservationQuestionAnswer {
    public id: number;
    public identityQuestion: boolean;
    public isRequired: boolean;
    public question: string;
    public questionId: number;
    public questionType: ReservationQuestionType;
    public answer: string;

    constructor(question: ReservationQuestion, locale: string) {
        this.questionId = question.id;
        this.question = question.translations?.find(x => x.locale.slice(0, 2) == locale)?.translation ?? question.question;
        this.identityQuestion = question.identityQuestion;
        this.isRequired = question.required;
        this.questionType = question.questionType;
    }
}